import React, { useState } from "react";
import Bases from "./bases";
import GraphDisplay from "./graphDisplay";

export default function Dashboard() {
  const [selectedBases, setSelectedBases] = useState([]);

  return (
    <div className="flex flex-1 bg-white-less dark:bg-dark-bg">
      {/* Bases na esquerda */}
      <div className="w-[300px] border-r dark:border-dark-border">
        <Bases onSelect={setSelectedBases} />
      </div>

      {/* Gráficos na direita */}
      <div className="h-screen flex-1 p-4 align-middle justify-center">
        <GraphDisplay data={selectedBases} />
      </div>
    </div>
  );
}
